import {
    nameToInitials,
    stringToColor,
    trimStrings,
} from "./utils";

export const utils = {
    nameToInitials,
    stringToColor,
    trimStrings,
};

export { default as Button } from "./components/Button/Button";
